<template>
  <div class="clientContent">
    <div class="clientForm">
      <el-form label-width="100px" :rules="rules" ref="clientFormRules" :model="clientInfo">
        <div class="flexStyle mainContent">
          <div>
            <upload-image
              :imageUrl.sync="clientInfo.cilentLogo"
              :imageUrls.sync="clientInfo.cilentLogoKey"
            />
            <el-button v-if="clientInfo.cilentLogoKey" @click="deleteImg" style="margin-top: 10px"
              >删除图片</el-button
            >
          </div>
          <div>
            <div class="flexStyle">
              <el-form-item label="公司名称：" prop="cientName">
                <el-input class="large_input" v-model="clientInfo.cientName"></el-input>
              </el-form-item>
              <el-form-item label="公司别称：">
                <el-input class="large_input" v-model="clientInfo.cilentAccessoryName"></el-input>
              </el-form-item>
            </div>
            <div class="flexStyle">
              <el-form-item label="官网：">
                <el-input class="large_input" v-model="clientInfo.cilentOfficial"></el-input>
              </el-form-item>
              <el-form-item label="总部地址：">
                <!-- <el-input class="large_input" v-model="clientInfo.workIntro"></el-input>
               -->
                <CascaderArea
                  :country="clientInfo.workIntro"
                  :province="clientInfo.companyProvince"
                  :city="clientInfo.companyCity"
                  @searchArae="searchArae"
                />
              </el-form-item>
            </div>
            <div class="flexStyle">
              <el-form-item label="所属行业：">
                <drop-down-box :selectValue.sync="clientInfo.cilentIndustry" typeCode="004" />
              </el-form-item>
              <el-form-item label="企业性质：">
                <el-select v-model="clientInfo.cilentNature" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in cilentNature"
                    :key="index"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="企业规模：">
                <el-select v-model="clientInfo.cilentScale" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in cilentScale"
                    :key="index"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="融资轮次：">
                <drop-down-box :selectValue.sync="clientInfo.cilentFinancing" typeCode="002" />
              </el-form-item>
            </div>
            <el-form-item label="一句话描述：">
              <el-input v-model="clientInfo.cilentDescribe"></el-input>
            </el-form-item>
            <el-form-item label="公司简介：">
              <el-input
                v-model="clientInfo.cilentSynopsis"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 10 }"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <div class="flexStyle">
            <el-form-item label="合作状态：" style="margin-right: 50px">
              <drop-down-box :selectValue.sync="clientInfo.cilentState" typeCode="001" />
            </el-form-item>
            <el-form-item label="首次合作日期：" label-width="120px">
              <el-date-picker
                v-model="clientInfo.cilentAssignment"
                type="month"
                placeholder="请选择"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <el-form-item label="合作协议："
            ><uploadFile
              :lookUrl.sync="clientInfo.clientAlias"
              :saveUrl.sync="clientInfo.clientAlias"
          /></el-form-item>
          <el-form-item label="主要联系人：">
            <div
              class="inputStyle"
              v-for="(item, index) in clientInfo.cilentLinkmanList"
              :key="index"
            >
              <el-input
                class="small_input"
                placeholder="姓名"
                v-model="item.linkmanName"
              ></el-input>
              <el-input
                class="small_input"
                placeholder="职位"
                v-model="item.linkmanPosition"
              ></el-input>
              <el-input
                class="small_input"
                placeholder="手机号"
                v-model="item.linkmanPhone"
              ></el-input>
              <el-input
                class="small_input"
                placeholder="邮箱"
                v-model="item.linkmanMail"
              ></el-input>
              <el-input
                class="small_input"
                placeholder="微信号"
                v-model="item.likmanWechat"
              ></el-input>
              <span
                class="iconStyle el-icon-circle-plus-outline"
                @click="addCilentLinkmanList()"
                v-if="clientInfo.cilentLinkmanList.length == index + 1"
              ></span>
              <span
                class="iconStyle el-icon-remove-outline"
                @click="removeCilentLinkmanList(index)"
                v-if="clientInfo.cilentLinkmanList.length > 1"
              ></span>
            </div>
          </el-form-item>
          <el-form-item label="客户经理：">
            <div class="inputStyle">
              <el-input
                class="small_input"
                placeholder="姓名"
                v-model="clientInfo.cilentManagerList[0].linkmanName"
              ></el-input>
              <el-input
                class="small_input"
                placeholder="职位"
                v-model="clientInfo.cilentManagerList[0].linkmanPosition"
              ></el-input>
              <el-input
                class="small_input"
                placeholder="手机号"
                v-model="clientInfo.cilentManagerList[0].linkmanPhone"
              ></el-input>
              <el-input
                class="small_input"
                placeholder="邮箱"
                v-model="clientInfo.cilentManagerList[0].linkmanMail"
              ></el-input>
              <el-input
                class="small_input"
                placeholder="微信号"
                v-model="clientInfo.cilentManagerList[0].likmanWechat"
              ></el-input>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="buttonStyle">
      <el-button class="saveButton" @click="save">保存</el-button>
      <el-button class="cancelButton" @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import uploadFile from '@/components/UploadFile'
import CascaderArea from '@/components/CascaderArea.vue'
import UploadImage from '@/components/UploadImage.vue'
import { insertCilent, getCilentConditionByid } from '@/api/cutsomer.js'
import DropDownBox from '../../../components/DropDownBox.vue'
export default {
  components: {
    UploadImage,
    uploadFile,
    CascaderArea,
    DropDownBox
  },
  data() {
    return {
      options: ['计算机', '自动化', '人工智能', '建筑', '房地产'],
      cilentNature: ['民企', '国企', '上市公司', '外企', '合资', '政府', '事业单位', '其他'],
      cilentScale: [
        '1-49人',
        '50-99人',
        '100-499人',
        '500-999人',
        '1000-2000人',
        '2000-5000人',
        '5000-10000人',
        '10000人以上'
      ],
      cilentState: ['未合作', '合作中', '待续约'],
      clientInfo: {
        cilentLogo: '', //客户公司logo
        cientName: '', //客户公司名称
        cilentAccessoryName: '', //客户附加名称
        // cilentAccessoryUrl: '', //客户附件路径
        clientAlias: '', //客户公司合作协议
        clientAliasKey: '', //客户公司合作协议
        cilentAssignment: '', //客户公司首次合作日期
        cilentDescribe: '', //客户公司一句话描述
        cilentFinancing: '', //客户公司融资轮次
        cilentIndustry: '', //客户公司所属行业
        cilentIndustryList: [], //客户公司所属行业
        cilentLinkman: '', //客户公司主要联系人
        cilentOfficial: '', //客户公司官网
        workIntro: '', //总部地址
        cilentSynopsis: '', //公司简介
        cilentNature: '', //企业性质
        cilentScale: '', //企业规模
        cilentState: '', //合作状态
        cilentLinkmanList: [
          {
            likmanWechat: '', //微信号
            linkmanMail: '', //联系人邮件
            linkmanName: '', //联系人姓名
            linkmanPhone: '', //联系人电话
            linkmanPosition: '' //联系人职位
          }
        ],
        cilentManagerList: [
          {
            likmanWechat: '', //微信号
            linkmanMail: '', //联系人邮件
            linkmanName: '', //联系人姓名
            linkmanPhone: '', //联系人电话
            linkmanPosition: '' //联系人职位
          }
        ]
      },
      rules: {
        cientName: [{ required: true, message: '请填写公司名称', trigger: 'onChange' }]
      }
    }
  },
  computed: {
    Authorization() {
      return sessionStorage.getItem('token')
    },
    clientType() {
      return this.$route.query.clientType
    },
    clientId() {
      return this.$route.query.id
    },
    searchInfo() {
      if (this.$route.query.searchInfo) {
        return JSON.parse(this.$route.query.searchInfo)
      } else {
        return null
      }
    }
  },
  created() {
    this.$store.commit('changeQueryInfo', this.searchInfo)

    if (this.clientType) {
      this.getCilentConditionByid()
    }
  },
  methods: {
    // 单个查询
    async getCilentConditionByid() {
      const res = await getCilentConditionByid({ byid: this.clientId })
      if (res.data.resultCode == 200) {
        this.clientInfo = res.data.data
        if (!this.clientInfo.cilentManagerList || this.clientInfo.cilentManagerList.length == 0) {
          this.clientInfo.cilentManagerList = [
            {
              likmanWechat: '', //微信号
              linkmanMail: '', //联系人邮件
              linkmanName: '', //联系人姓名
              linkmanPhone: '', //联系人电话
              linkmanPosition: '' //联系人职位
            }
          ]
        }
        if (!this.clientInfo.cilentLinkmanList || this.clientInfo.cilentLinkmanList.length == 0) {
          this.clientInfo.cilentLinkmanList = [
            {
              likmanWechat: '', //微信号
              linkmanMail: '', //联系人邮件
              linkmanName: '', //联系人姓名
              linkmanPhone: '', //联系人电话
              linkmanPosition: '' //联系人职位
            }
          ]
        }
      }
    },
    //   添加联系人
    addCilentLinkmanList() {
      this.clientInfo.cilentLinkmanList.push({
        likmanWechat: '', //微信号
        linkmanMail: '', //联系人邮件
        linkmanName: '', //联系人姓名
        linkmanPhone: '', //联系人电话
        linkmanPosition: '' //联系人职位
      })
    },
    // 国家地区
    searchArae(val) {
      this.clientInfo.workIntro = val.country

      this.clientInfo.companyProvince = val.province

      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.clientInfo.companyCity = val.city
      }
    },
    //   删除联系人
    removeCilentLinkmanList(index) {
      this.clientInfo.cilentLinkmanList.splice(index, 1)
    },
    // 保存
    save() {
      this.$refs.clientFormRules.validate(async (valid) => {
        if (valid) {
          const res = await insertCilent(this.clientInfo)
          if (res.data.resultCode === 200) {
            if (this.clientType) {
              this.$message.success('修改成功')
            } else {
              this.$message.success('新增成功')
            }
            this.$router.go(-1)
          }
        }
      })
    },
    // 返回
    cancel() {
      this.$router.go(-1)
    },
    deleteImg() {
      this.clientInfo.cilentLogo = ''
      this.clientInfo.cilentLogoKey = ''
    }
  }
}
</script>

<style scoped lang="less">
.mainContent {
  background-color: #fff;
  padding: 20px;
}
.flexStyle {
  display: flex;
}
.inputStyle {
  /deep/ .el-input {
    margin: 0 5px 5px 0;
  }
  .iconStyle {
    display: inline-block;
    height: 100%;
    font-size: 28px;
    vertical-align: middle;
    cursor: pointer;
    color: #17757a;
  }
}
.buttonStyle {
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 100%;
  background-color: #fff;
  padding: 0 10px 10px 10px;
}
/deep/ .saveButton {
  background-color: #17757a !important;
  color: #fff;
  padding: 10px 30px;
}
/deep/ .cancelButton {
  border-color: #17757a !important;
  color: #17757a;
  padding: 10px 30px;
}
/deep/ .el-button:focus,
.el-button:hover {
  background-color: #fff;
  color: #17757a;
}
/deep/ .el-upload-list__item.is-success .el-upload-list__item-name:focus,
.el-upload-list__item.is-success .el-upload-list__item-name:hover {
  color: #17757a;
}
// .clientContent{
//   height: 100%;
//   overflow: auto;
//   .clientForm{

//   }
// }
</style>
